<template>
  <div class="customize-availability-vue">
    <p>
      Here you can add custom availability to your schedule.
      Highlight the hours you would like to be made available
      or unavailable and click save.
    </p>
    <loader v-show="saving || loading" />
    <div v-show="!saving && !loading" class="customizer-and-results">
      <div id="cronofy-additional-availability" />
      <div class="results" v-if="addedSlots.length || removedSlots.length">
        <div class="change-block" v-if="addedSlots.length">
          <span class="title">Add Availability</span>
          <ul>
            <li v-for="slot of addedSlots" :key="slot.start.toISOString()">
              <span class="little">{{slot.start | format("MMMM")}} </span>
              <span class="big">{{slot.start | format("Do")}} </span>
              <span class="little">{{slot.start | format("YYYY")}} </span>
              <span class="big">{{slot.start | format("h:mm")}} </span>
              <span class="big">{{slot.start | format("A")}} </span>
              <span class="little">to </span>
              <template v-if="slot.start.local().date() === slot.end.local().date()">
                <span class="big">{{slot.end | withTimeZone | format("h:mm")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("A")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("z")}} </span>
              </template>
              <template v-else> 
                <span class="little">{{slot.end | withTimeZone | format("MMMM")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("Do")}} </span>
                <span class="little">{{slot.end | withTimeZone | format("YYYY")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("h:mm")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("A")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("z")}} </span>
              </template>
            </li>
          </ul>
        </div>
        <div class="change-block" v-if="removedSlots.length">
          <span class="title">Remove Availability</span>
          <ul>
            <li v-for="slot of removedSlots" :key="slot.start.toISOString()">
              <span class="little">{{slot.start | format("MMMM")}} </span>
              <span class="big">{{slot.start | format("Do")}} </span>
              <span class="little">{{slot.start | format("YYYY")}} </span>
              <span class="big">{{slot.start | format("h:mm")}} </span>
              <span class="big">{{slot.start | format("A")}} </span>
              <span class="little">to </span>
              <template v-if="slot.start.local().date() === slot.end.local().date()">
                <span class="big">{{slot.end | withTimeZone | format("h:mm")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("A")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("z")}} </span>
              </template>
              <template v-else> 
                <span class="little">{{slot.end | withTimeZone | format("MMMM")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("Do")}} </span>
                <span class="little">{{slot.end | withTimeZone | format("YYYY")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("h:mm")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("A")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("z")}} </span>
              </template>
            </li>
          </ul>
        </div>
        <div class="change-block" v-if="conflicts.length">
          <span class="title">Conflicts</span>
          <ul>
            <li v-for="slot of conflicts" :key="slot.key">
              <span class="little">{{slot.start | format("MMMM")}} </span>
              <span class="big">{{slot.start | format("Do")}} </span>
              <span class="little">{{slot.start | format("YYYY")}} </span>
              <span class="big">{{slot.start | format("h:mm")}} </span>
              <span class="big">{{slot.start | format("A")}} </span>
              <span class="little">to </span>
              <template v-if="slot.start.local().date() === slot.end.local().date()">
                <span class="big">{{slot.end | withTimeZone | format("h:mm")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("A")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("z")}} </span>
              </template>
              <template v-else> 
                <span class="little">{{slot.end | withTimeZone | format("MMMM")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("Do")}} </span>
                <span class="little">{{slot.end | withTimeZone | format("YYYY")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("h:mm")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("A")}} </span>
                <span class="big">{{slot.end | withTimeZone | format("z")}} </span>
              </template>
              <span class="big" v-if="slot.profileName">
                - {{slot.profileName}}
              </span>
              <span class="big" v-if="slot.calendarName">
                - {{slot.calendarName}}
              </span>
            </li>
          </ul>
        </div>
        <div class="buttons" >
          <button type="button"
            class="btn btn-secondary"
            @click="clearCustomizations">
            Clear
          </button>
          <span class="conflict-warning" v-if="conflicts.length">
            Remove conflicting availability to save.
          </span>
          <button type="button"
            class="btn btn-primary"
            v-else
            @click="saveCustomizations">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import CounselorClient from '@/api/CounselorClient';
import CronofyClient from '@/api/CronofyClient';
import moment from 'moment';
export default {
  components: {
    Loader
  },
  props: {
    counselorId:{
      type: Number, 
      required: true,
    }
  },
  data() {
    return {
      counselorClient: new CounselorClient(this.$http),
      cronofyClient: new CronofyClient(this.$http),
      elementToken: null,
      element: null,
      availablePeriods: [],
      addedSlots: [],
      removedSlots: [],
      saving: false,
      loading: true,
      events: [],
      availabilityQuery: null,
      ignoredFirstDisplayDatesChanged: false,
    }
  },
  async mounted() {
    const response = await this.counselorClient.getAvailabilityToken(this.counselorId);
    this.elementToken = response.token.token;
    this.buildAvailabilityQuery(response.token.subjects);
    this.refreshAvailability();

    this.element = CronofyElements.AvailabilityViewer({
        tzid: this.$now.timezone().name,
        element_token: this.elementToken,
        target_id: "cronofy-additional-availability",
        translations: {
          en: {
            availability_viewer: {
              selected: 'Remove Availability',
              free: 'Add Availability',
              busy: 'Existing Availability'
            }
          }
        },
        availability_query: this.availabilityQuery,
        config: {
            start_time: "08:00",
            end_time: "19:00",
            interval: 30,
            mode: 'free_select',
            slot_selection: 'unrestricted',
        },
        styles: {
            prefix: "additional_availability",
            colors: {
              hairline: "#5c6877",
              available: '#75fffd',
              unavailable: '#5c6877',
            }
        },
        callback: this.handleCronofyNotification.bind(this),
    })
  },
  computed: {
    conflicts() {
      return this.events
        .filter(event => this.addedSlots.some(add => event.start < add.end && event.end > add.start));
    }
  },
  methods: {
    buildAvailabilityQuery(subjects) {
      this.availabilityQuery = {
        max_results: 512,
        participants: [
          {
            required: "all",
            members: subjects.map(sub => ({
              sub: sub, 
              managed_availability: true
            })),
          }
        ],
        start_interval: { minutes: 30 },
        required_duration: { minutes: 30 },
        query_periods: [
         { 
           start: moment().startOf('hour').add(1, 'hour').toISOString(), 
           end: moment().startOf('day').add(35, 'days').subtract(1, 'minute').toISOString()
         },
        ],
      };
    },
    async getCalendarEvents(start, end) {
      try {
        const response = await this.counselorClient.getCalendarEvents(this.counselorId, start, end);
        response.events.forEach(event => {
          const event_key = `${event.id}_${event.start}`;
          if(this.events.some(x => x.key == event_key))
            return;

          const [calendarName, profileName] = event.summary.split(',');
          this.events.push({
            ...event,
            key: event_key,
            start: moment(event.start),
            end: moment(event.end),
            calendarName,
            profileName
          })
        });
      } catch (ex) {
        console.error(ex.message);
      }
    },
    async refreshAvailability() {
      const response = await this.cronofyClient.getAvailability(this.elementToken, this.availabilityQuery)
      this.availablePeriods = response.available_periods.map(x => ({
        start: moment(x.start),
        end: moment(x.end),
      }));
    },
    handleCronofyNotification(payload) {
      if (payload.notification.type === 'displayed_dates_changed') {
        this.loading = false;
        if(!this.ignoredFirstDisplayDatesChanged) {
          // Cronofy sets display dates twice in initialization. 
          // Ignore the first one.
          this.ignoredFirstDisplayDatesChanged = true;
          return;
        }

        this.getCalendarEvents(
          moment(payload.notification.firstDay).startOf('day').toISOString(), 
          moment(payload.notification.lastDay).endOf('day').toISOString());
      }

      if(payload.notification.type === "query_periods_edited") {
        this.updateAddedAndRemovedAvailabilitySlots(
          payload.notification.query_periods)
      }

    },
    /**
     * Via ChatGPT:
     * The `handleCronofyNotification` function appears to handle a notification related to query periods. Here's a breakdown of what it does:
     * 
     * 1. It checks if the notification type is "query_periods_edited." If not, it immediately returns.
     * 2. It initializes two arrays, `addedSlots` and `removedSlots`, to store slots that are added or removed.
     * 3. It checks if the `changes` array is empty. If it is, the function returns.
     * 4. It transforms the `availablePeriods` and `payload.notification.query_periods` arrays by converting the start and end times to `moment` objects using the `map` function and assigns them to `availabilities` and `changes` arrays, respectively.
     * 5. It initializes two index variables, `currentAvailableIndex` and `currentChangeIndex`, to keep track of the current index in the `availabilities` and `changes` arrays.
     * 6. It enters a `do-while` loop to iterate over the changes and availabilities.
     * 7. Inside the loop, it retrieves the current availability and change objects based on the current indices.
     *******
     * 8. It performs a series of comparisons and conditional statements to determine whether a slot should be added or removed based on the availability and change intervals. The specific scenarios handled include cases where the change starts after the availability ends, change ends before availability starts, change overlaps with availability, and more. If none of the scenarios match, an error message is logged.
     *******
     * 9. After each iteration, the loop continues until all changes have been processed (i.e., `currentChangeIndex` reaches the length of the `changes` array).
     *
     * In summary, this function handles the notification related to query periods and determines the added and removed slots based on the changes and available periods. It populates the `addedSlots` and `removedSlots` arrays accordingly.
     */
    updateAddedAndRemovedAvailabilitySlots(query){
      this.addedSlots = [];
      this.removedSlots = [];

      if(!query.length)
        return;

      const availabilities = this.availablePeriods
        .map(x => ({ start: moment(x.start), end: moment(x.end)}))
      const changes = query
        .map(x => ({ start: moment(x.start), end: moment(x.end)}));

      let currentAvailableIndex = 0;
      let currentChangeIndex = 0;
      
      do {
        let existing = availabilities[currentAvailableIndex];
        let change = changes[currentChangeIndex];

        if(currentAvailableIndex == availabilities.length) {
          this.addedSlots.push(change);
          currentChangeIndex++;
        } else if (change.start.isSameOrAfter(existing.end)) {
          currentAvailableIndex++;
        } else if (change.end.isSameOrBefore(existing.start)) { 
          this.addedSlots.push(change);
          currentChangeIndex++;
        } else if (change.start.isSameOrAfter(existing.start)) {
          if(change.end.isSameOrBefore(existing.end)){
            this.removedSlots.push(change);
            currentChangeIndex++;
          } else {
            this.removedSlots.push({start: change.start, end: existing.end});
            change.start = existing.end;
            currentAvailableIndex++;
          }
        } else if (change.end.isSameOrBefore(existing.end)) {
          this.addedSlots.push({ start:change.start, end: existing.start});
          this.removedSlots.push({ start:existing.start, end: change.end });
          currentChangeIndex++;
          if(change.end.isBefore(existing.end)) {
            existing.start = change.end;
            currentAvailableIndex++;
          }
        } else if(change.end.isAfter(existing.end) && change.start.isBefore(existing.start)) {
          this.addedSlots.push({start: change.start, end: existing.start})
          this.removedSlots.push(existing);
          change.start = existing.end;
          currentAvailableIndex++;
        } else {
          console.error("Not accounting for scenario", change, existing, changes, availabilities);
        }
      } while(currentChangeIndex < changes.length);
    },
    async clearCustomizations() {
      this.events = [];
      this.addedSlots = [];
      this.removedSlots = [];
      this.element.refresh();
      await this.refreshAvailability();
    },
    async saveCustomizations() {
      try {
        this.saving = true;
        
        await this.counselorClient.updateAvailability(
          this.counselorId,
          this.addedSlots.map(x => ({ start: x.start.toISOString(), end: x.end.toISOString() })),
          this.removedSlots.map(x => ({ start: x.start.toISOString(), end: x.end.toISOString() })));
        
        // Wait for domain events to catch up.
        await this.delay(2000);
        await this.clearCustomizations();

        this.$store.commit('setGlobalAlert', {
          msg: 'Availability updated!',
        });
      } catch(ex) {
        console.error(ex);
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed updating availability. Please try again. If the issue persists, please contact support.', 
          error: true,
        });
      } finally {
        this.saving = false;
      }
    },
    delay(milliseconds){
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },
  }
}
</script>

<style lang="scss">
.customize-availability-vue {
  .title {
    letter-spacing: .1rem;
    text-transform: uppercase;
    font-size: 12px;
    color: $green;
  }
  .little {
    font-size: 12px;
    color: $light-gray;
  }
  .big {
    font-size: 16px;
    color: $light-gray;
  }  
  .conflict-warning {
    font-weight: 600;
    color: $red;
  }
  @media (min-width: 1000px) {
    .customizer-and-results {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .results {
        flex: 1;
        padding: 0px 0px 0px 10px;
        .change-block {
          width: 100%;
          border: 5px $blue solid;
          border-radius: 5px;
          margin: 0px 0px 10px 0px;
          padding: 10px 10px 0px 10px;
        }
        .buttons {
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          margin: 0px 0px 1px 0px;
        }
      }
    }
  }
  @media (max-width: 999px) {
    .customizer-and-results {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap-reverse;
      .results {
        flex: 1;
        .change-block {
          width: 700px;
          border: 3px $blue solid;
          border-radius: 5px;
          margin: 10px 0px 0px 0px;
          padding: 10px 10px 0px 10px;
        }
        .buttons {
          width: 700px;
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          margin: 10px 0px 10px 0px;
        }
      }
    }
  }
  #cronofy-additional-availability{
    width: 700px;     
  }
  .additional_availability {
    .additional_availability__slot-background--selected-busy {
      background: $approval-green;
    }
    .additional_availability__slot-background--selected {
      background: repeating-linear-gradient(to right bottom, $red, $red 10.6066px, $dark-blue 10.6066px, $dark-blue 21.2132px) 0% 0% / 30px 30px;
    }
    .additional_availability__example--selected {
      background: repeating-linear-gradient(to right bottom, $red, $red 5.6066px, $dark-blue 5.6066px, $dark-blue 10.2132px) 0% 0% / 30px 30px;
    }
    .additional_availability__example--free {
      background: $approval-green;
    }
    .additional_availability__slot-background--available {
      background: $green;
    }
    .additional_availability__example--available {
      background: $green;
    }
    .additional_availability__slot-background--busy {
      background: $dark-blue;
    }
    .additional_availability__example--busy {
      background: $green;
    }
    .additional_availability__time-text {
      color: $white;
    }
    .additional_availability__time-expander-button {
      svg {
        fill: $white;
      }
    }
    .additional_availability__time-expander-button:hover {
      svg {
        fill: $green;
      }
    }
    .additional_availability__navigation {
    position: absolute;
    top: 0;
    right: 0;
    }
    .additional_availability__month-labels {
        padding-top: 20px;
    }
  }
}
</style>